import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import type { ErrorsTableProps } from './types';

export function ErrorsTable({ fieldErrors }: ErrorsTableProps) {
  return (
    <div className="h-[350px] rounded-md border overflow-auto">
      <Table caption="Validation errors by row and field">
        <TableHeader>
          <TableRow>
            <TableHead className="w-20">Row</TableHead>
            <TableHead>Field</TableHead>
            <TableHead>Error</TableHead>
            <TableHead>Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {fieldErrors.map((fieldError) => (
            <TableRow key={`${fieldError.row_number}-${fieldError.field}-${fieldError.message}`}>
              <TableCell className="font-medium">{fieldError.row_number}</TableCell>
              <TableCell>{fieldError.field}</TableCell>
              <TableCell className="text-destructive">{fieldError.message}</TableCell>
              <TableCell className="max-w-[150px] truncate font-mono text-xs">
                {fieldError.value || '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
